var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsDnd = function SvgDotsDnd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 4c-.825 0-1.5.675-1.5 1.5S8.175 7 9 7s1.5-.675 1.5-1.5S9.825 4 9 4M9 10.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5M9 17c-.825 0-1.5.675-1.5 1.5S8.175 20 9 20s1.5-.675 1.5-1.5S9.825 17 9 17M15 4c-.825 0-1.5.675-1.5 1.5S14.175 7 15 7s1.5-.675 1.5-1.5S15.825 4 15 4M15 10.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5M15 17c-.825 0-1.5.675-1.5 1.5S14.175 20 15 20s1.5-.675 1.5-1.5S15.825 17 15 17"
  })));
};
export default SvgDotsDnd;